/*
*
* Comunications Api
*
* @version 1.0.0
* @author Patrizia Petrera
* @since 29-Jan-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/comunications/comunications')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}
// @generator api:method

export async function getComunications (params) {
  let data
  const pagination = `?page=${params.page || 0}&limit=${params.limit || 5}`
  const order = `&order=${params.order || 'DESC'}`
  const categoryArray = (params.category || []).flatMap(category =>
    category === 'FRAUD_PREVENTION' ? ['FRAUD_PREVENTION', 'AML_REMINDER'] : [category]
  )
  const category = `&category=${categoryArray.length > 0 ? `${categoryArray.join(',')}` : ''}`
  const visibility = `&visibility=${params.visibility || ''}`

  try {
    data = await axios({
      method: 'get',
      url: `services/communication-service/communications${pagination}${order}${category}${visibility}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getAlerts (params) {
  let data
  const pagination = `?page=${params.page || 0}&limit=${params.limit || 5}`
  const order = `&order=${params.order || 'DESC'}`
  const visibility = `&visibility=${params.visibility || ''}`

  try {
    data = await axios({
      method: 'get',
      url: `services/communication-service/alerts${pagination}${order}${visibility}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function setAlertRead (params) {
  let data

  try {
    data = await axios({
      method: 'put',
      url: 'services/communication-service/alerts/read',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getNewMessages (params) {
  let data
  const type = `?type=${params.payload || 'ALL'}` // COMMUNICATIONS, ALERTS, ALL

  try {
    data = await axios({
      method: 'get',
      url: `services/communication-service/communications/new-messages${type}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getComunicationDetail (params) {
  let data
  const id = params.id

  try {
    data = await axios({
      method: 'get',
      url: `services/communication-service/communications/${id}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
